import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Websites.vue"),
    meta: { title: "Dashboard" },
  },
  {
    path: "/account",
    name: "account",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Account.vue"),
    meta: { title: "My Account" },
  },
  {
    path: "/appsumo",
    name: "appsumo",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AppSumo.vue"),
    meta: { title: "AppSumo" },
  },
  {
    path: "/websites/:domainID",
    name: "website",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Website.vue"),
    meta: { title: "Website" },
  },
  {
    path: "/widget/:domain/:widgetID",
    name: "widget",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Widget.vue"),
    meta: { title: "Widget" },
  },
  {
    path: "/login",
    name: "login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Login.vue"),
    meta: { title: "Login" },
  },
];

const router = new VueRouter({
  routes,
});
const DEFAULT_TITLE = "Some Default Title";
router.beforeEach((to, from, next) => {
  if (
    to.matched.some((record) => record.name == "login") &&
    store.getters.isAuthenticated
  ) {
    next({
      path: "/",
    });
  }

  if (to.matched.some((record) => record.name != "login")) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.isAuthenticated) {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

router.afterEach((to) => {
  document.title = to.meta.title || DEFAULT_TITLE;
});

export default router;
